export const moneda = [
  {
    label: "Id",
    name: "idmoneda",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Descripción",
    name: "descripcion",
    type: "STRING",
    showOnList: true,
  },
  {
    label: "Código ISO",
    name: "codigo_iso",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
];
